var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class RequestQueue {
    constructor(maxConcurrent = 3) {
        this.queue = [];
        this.running = 0;
        this.maxConcurrent = maxConcurrent;
    }
    /**
     * Add a promise-returning function to the queue
     * @param fn Function that returns a Promise
     * @returns Promise that resolves with the result of the function
     */
    add(fn) {
        return new Promise((resolve, reject) => {
            this.queue.push({ fn, resolve, reject });
            this.processNext();
        });
    }
    /**
     * Clear all pending requests from the queue
     * Running requests will continue to completion
     */
    flush() {
        // Reject all pending requests
        this.queue.forEach(item => {
            item.reject(new Error('Queue flushed'));
        });
        this.queue = [];
    }
    /**
     * Get the current queue size (pending requests)
     */
    get size() {
        return this.queue.length;
    }
    /**
     * Get the number of currently running requests
     */
    get activeCount() {
        return this.running;
    }
    /**
     * Update the maximum concurrent requests limit
     */
    setMaxConcurrent(max) {
        this.maxConcurrent = max;
        // Process any queued items if we increased the limit
        this.processNext();
    }
    processNext() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.running >= this.maxConcurrent || this.queue.length === 0) {
                return;
            }
            const item = this.queue.shift();
            this.running++;
            try {
                const result = yield item.fn();
                item.resolve(result);
            }
            catch (error) {
                item.reject(error);
            }
            finally {
                this.running--;
                // Process next item in queue
                this.processNext();
            }
        });
    }
}
//# sourceMappingURL=Queue.js.map